import { Injectable, Inject } from '@angular/core';
import { NgxFfmConfig } from './ngx-ffm-config';
import { Observable, Subject } from 'rxjs';
import { NGX_FFM_TOKEN } from './ngx-ffm-config.token';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NgxFfmService {

  filechange: Subject<any[]> = new Subject<any>();

  constructor(
    @Inject(NGX_FFM_TOKEN)
    private ngxFfmConfig: NgxFfmConfig,
    private http: HttpClient
  ) {
  }

 async getDocuments(filepath) {
    const resp = this.http.get<any>(
      this.ngxFfmConfig.apiHost + '/documents',
      {
        params: {
          filepath
        }
      }
    ).toPromise();
    return resp;
  }


  async getAllFiles(object) {
    const resp = this.http.get<any>(
      this.ngxFfmConfig.apiHost + '/documents/alldownload',
      {
        params: object
      }
    ).toPromise();
    return resp;
  }

  async convertDocument(object) {
    const resp = this.http.post<any>(
      this.ngxFfmConfig.apiHost + '/documents/convert',
      object
    ).toPromise();
    return resp;
  }

  async getDocumentOpen(filename, filepath) {
    const resp = this.http.get(
      this.ngxFfmConfig.apiHost + '/documents/download',
      {
        params: {
          filename, filepath
        }
      }
    ).toPromise();
    return resp;
  }

  // post

  postDocument(formData, filepath) {
    return this.http.post<any>(
      this.ngxFfmConfig.apiHost + '/documents',
      formData,
      {
        reportProgress: true,
        observe: 'events',
        params: {
          filepath
        }
      }
    ).pipe(map((event) => {
      switch (event.type) {

        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };

        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    }
    ));
  }

  async postRegistry(filepath, dirname) {
    const resp = this.http.post(
      this.ngxFfmConfig.apiHost + '/documents/registry',
      {
        filepath,
        dirname
      }
    ).toPromise()
    return resp;
  }

  // delete, nincs rá szükség

  async deleteDocumentLocal(filename) {
    const resp = this.http.delete(
      this.ngxFfmConfig.apiHost + '/documents/delete',
      {
        params: {
          filename
        }
      }
    ).toPromise();
    return resp;
  }

  deleteDocument(filenames, filepath): Observable<any> {
    return this.http.delete<any>(
      this.ngxFfmConfig.apiHost + '/documents',
      {
        params: {
          filenames, filepath
        }
      }
    );
  }

  setFiles(files: any[]) {
    this.filechange.next(files);
  }
}
